<script>
  export let item;
</script>

<article class="related-item">
  <a class="related-item__link" href={item.url}>
    <div class="related-item__image">
      {#if item.image}
        <img
          src={item.image.src}
          width={item.image.width}
          height={item.image.height}
          alt={item.image.alt}
          loading="lazy"
        />
      {/if}
    </div>
    <div class="related-item__logo">
      {#if item.logo}
        <img
          src={item.logo.src}
          width={item.logo.width}
          height={item.logo.height}
          alt={item.logo.alt}
          loading="lazy"
        />
      {/if}
    </div>
    <div class="related-item__content">
      <div class="related-item__title-wrap">
        {#if item.title}
          <h4 class="related-item__title">{item.title}</h4>
          <p class="related-item__title-small tagline">{item.title}</p>
        {/if}
        {#if item.cat}
          <p class="tagline related-item__cat">{item.cat}</p>
        {/if}
      </div>
      <div class="related-item__more">
        <p
          class="btn btn-icon btn-main btn-main--light related-item__more-large"
        >
          <span>Learn more</span>
          <i class="isax isax-arrow-right-1" />
        </p>
        <p class="btn btn-icon related-item__more-small">
          <span>Learn more</span>
          <i class="isax isax-arrow-right-1" />
        </p>
      </div>
    </div>
  </a>
</article>

<style lang="scss">
  .related-item {
    position: relative;

    &__link {
      display: block;
      overflow: hidden;
      aspect-ratio: 44/50;
      border-radius: 1rem;
      transition: border-radius 0.3s;

      @include resp-max('m') {
        aspect-ratio: 33/45;
      }

      @include resp-max('s') {
        height: 44rem;
      }

      &:hover {
      }
    }

    &__image {
      z-index: 0;
      position: relative;

      width: 100%;
      height: 100%;

      &::after,
      &::before {
        content: '';
        position: absolute;
        inset: 0;
      }

      &::after {
        z-index: 1;
        background: url(img/noise.png) 300px 300px;
      }

      &::before {
        @include gradient('grey', 'to top');

        z-index: 2;
        opacity: 0.8;
      }

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    &__logo {
      position: absolute;
      z-index: 1;
      inset: 0;

      display: flex;
      align-items: center;
      justify-content: center;

      transition: opacity 0.3s;

      img {
        max-height: 10rem;
        max-width: 40%;
      }

      .related-item__link:hover & {
        opacity: 0;

        // @include resp-max('m') {
        //   opacity: 1;
        // }
      }
    }

    &__content {
      opacity: 0;
      position: absolute;
      z-index: 1;
      inset: 0;

      color: rgb(var(--white));
      padding: 0 0 6rem;

      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-end;

      text-align: center;

      transition: opacity 0.3s;

      .related-item__link:hover & {
        opacity: 1;
      }
    }

    @include resp-max('m') {
      padding: 0 0 4rem;
    }

    &__title-wrap {
      padding: 0 7.6rem;

      .related-item__link:hover & {
        @include resp-max('m') {
          padding: 0 1rem;
        }
      }
    }

    &__title {
      @include resp-max('m') {
        display: none;
      }
    }

    &__title-small {
      @include resp-min('m') {
        display: none;
      }
    }

    &__cat {
      color: var(--royal-light);

      @include resp-max('m') {
        text-transform: none;
        font-size: 1.6rem;
        line-height: 1.6;
        margin-top: 0.5rem;
      }
    }

    &__more {
      margin-top: 6rem;
      position: relative;

      @include resp-max('m') {
        margin: 1rem auto 1rem;
        padding: 1rem 0;

        &::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          display: block;
          height: 1px;

          @include gradient('blue', '135deg');
        }

        & i {
          font-weight: 900;
          color: var(--royal);
        }
      }

      &-large {
        @include resp-max('m') {
          display: none;
        }
      }

      &-small {
        @include resp-min('m') {
          display: none;
        }
      }
    }
  }
</style>
